import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeLatest, takeEvery, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { GET_CLUB_MEMBER_SHIPMENT_SUCCESS } from 'redux/clubMemberShipments/constants';
import { GET_CLUB_PACKAGE_SUCCESS } from 'redux/clubPackages/constants';
import { GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS } from 'redux/clubSubscriptionShipments/constants';
import { GET_CLUB_SUCCESS } from 'redux/clubs/constants';

import {
  listClubMemberships,
  getClubMembership,
  editClubMembership,
  cancelClubMembership,
  addClubMembershipHold,
  editClubMembershipHold,
  deleteClubMembershipHold
} from './api';
import {
  LIST_CLUB_MEMBERSHIPS_REQUEST,
  GET_CLUB_MEMBERSHIP_REQUEST,
  GET_CLUB_MEMBERSHIP_SUCCESS,
  CLUB_MEMBERSHIP_REQUESTING,
  LIST_CLUB_MEMBERSHIPS_SUCCESS,
  RESET_CLUB_MEMBERSHIP_ISFETCHING,
  EDIT_CLUB_MEMBERSHIP_REQUEST,
  CANCEL_CLUB_MEMBERSHIP_REQUEST,
  ADD_CLUB_MEMBERSHIP_HOLD_REQUEST,
  EDIT_CLUB_MEMBERSHIP_HOLD_REQUEST,
  DELETE_CLUB_MEMBERSHIP_HOLD_REQUEST
} from './constants';

export function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      listClubMemberships,
      customerId(),
      action.queryString
    );
    yield call(listPayload, response.data);
    // find all club packages
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* listPayload(payload) {
  yield call(updateClubPackages, payload.clubMemberships);
  yield call(updateClubMemberShipments, payload.clubMemberships);
  yield call(updateClubSubscriptionShipments, payload.clubMemberships);
  yield call(updateClubs, payload.clubMemberships);

  payload.clubMemberships = payload.clubMemberships.map((clubMembership) => {
    const newMembership = transformMembership(clubMembership);
    return newMembership;
  });
  yield put({
    type: LIST_CLUB_MEMBERSHIPS_SUCCESS,
    payload
  });
}

function* updateClubPackages(clubMemberships) {
  const clubPackages = [];
  clubMemberships.forEach((clubMembership) => {
    if (clubMembership.clubPackage) {
      clubPackages.push(clubMembership.clubPackage);
    }
  });
  yield all(
    clubPackages.map((clubPackage) =>
      put({
        type: GET_CLUB_PACKAGE_SUCCESS,
        payload: clubPackage
      })
    )
  );
}

function* updateClubs(clubMemberships) {
  const clubs = [];
  clubMemberships.forEach((clubMembership) => {
    if (clubMembership.club) {
      clubs.push(clubMembership.club);
    }
  });
  yield all(
    clubs.map((club) =>
      put({
        type: GET_CLUB_SUCCESS,
        payload: club
      })
    )
  );
}

function* updateClubMemberShipments(clubMemberships) {
  const clubMemberShipments = [];
  clubMemberships.forEach((clubMembership) => {
    if (clubMembership.clubMemberShipment) {
      clubMemberShipments.push(clubMembership.clubMemberShipment);
    }
  });
  yield all(
    clubMemberShipments.map((clubMemberShipment) =>
      put({
        type: GET_CLUB_MEMBER_SHIPMENT_SUCCESS,
        payload: clubMemberShipment
      })
    )
  );
}

function* updateClubSubscriptionShipments(clubMemberships) {
  const clubSubscriptionShipments = [];
  clubMemberships.forEach((clubMembership) => {
    if (clubMembership.clubSubscriptionShipment) {
      clubSubscriptionShipments.push(clubMembership.clubSubscriptionShipment);
    }
  });
  yield all(
    clubSubscriptionShipments.map((clubSubscriptionShipment) =>
      put({
        type: GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS,
        payload: clubSubscriptionShipment
      })
    )
  );
}

export function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      getClubMembership,
      customerId(),
      action.clubMembershipId
    );
    yield call(updateClubPackages, [response.data]);
    yield call(updateClubMemberShipments, [response.data]);
    yield call(updateClubSubscriptionShipments, [response.data]);
    yield call(updateClubs, [response.data]);
    const newMembership = transformMembership(response.data);
    yield put({
      type: GET_CLUB_MEMBERSHIP_SUCCESS,
      payload: newMembership
    });
    return newMembership;
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

export function* edit(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    yield call(
      editClubMembership,
      customerId(),
      action.clubMembershipId,
      action.clubMembership
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });
    if (action.successFunction) {
      action.successFunction(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* cancel(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    yield call(
      cancelClubMembership,
      customerId(),
      action.clubMembershipId,
      action.clubMembership
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });
    action.successFunction(newMembership);
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* addHold(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    yield call(
      addClubMembershipHold,
      customerId(),
      action.clubMembershipId,
      action.onHold
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });
    if (action.successFunction) {
      action.successFunction(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

const transformMembership = (clubMembership) => {
  const newMembership = clubMembership;
  if (newMembership.clubPackage) {
    newMembership.activeClubPackageId = newMembership.clubPackage.id;
    delete newMembership.clubPackage;
  }
  if (newMembership.clubMemberShipment) {
    newMembership.activeClubMemberShipmentId =
      newMembership.clubMemberShipment.id;
    delete newMembership.clubMemberShipment;
  }
  if (newMembership.clubSubscriptionShipment) {
    newMembership.activeClubSubscriptionShipmentId =
      newMembership.clubSubscriptionShipment.id;
    delete newMembership.clubSubscriptionShipment;
  }
  return newMembership;
};

export function* editHold(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    yield call(
      editClubMembershipHold,
      customerId(),
      action.clubMembershipId,
      action.id,
      action.onHold
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });
    if (action.successFunction) {
      action.successFunction(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* deleteHold(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    yield call(
      deleteClubMembershipHold,
      customerId(),
      action.clubMembershipId,
      action.id
    );
    const newMembership = yield call(get, {
      clubMembershipId: action.clubMembershipId
    });
    if (action.successFunction) {
      action.successFunction(newMembership);
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  yield takeLatest(LIST_CLUB_MEMBERSHIPS_REQUEST, list);
  yield takeLatest(GET_CLUB_MEMBERSHIP_REQUEST, get);
  yield takeEvery(EDIT_CLUB_MEMBERSHIP_REQUEST, edit);
  yield takeLatest(CANCEL_CLUB_MEMBERSHIP_REQUEST, cancel);
  yield takeLatest(ADD_CLUB_MEMBERSHIP_HOLD_REQUEST, addHold);
  yield takeLatest(EDIT_CLUB_MEMBERSHIP_HOLD_REQUEST, editHold);
  yield takeLatest(DELETE_CLUB_MEMBERSHIP_HOLD_REQUEST, deleteHold);
}

export default function* clubMembershipSagas() {
  yield all([watchList()]);
}

const customerId = () => jwtDecode(Cookies.get('customerToken')).sub;
